import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAllClasses as apiFn } from "../../api/apiClasses";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useRestoreAllClasses() {
    const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: restoreAllClasses, isPending: isRestore } = useMutation({
        mutationFn: (req) => apiFn(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["classes"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); },
    });
    return { restoreAllClasses, isRestore };
}
